/**
 * Created by piotr.pozniak@thebeaverhead.com on 07/03/2023
 */

import React, { useContext, useMemo } from "react";
import classNames from "classnames";
import WidgetSettingsContext from "../../../../contexts/WidgetSettingsContext";

/**
 * Cta component renders a call-to-action button based on the provided ctas and widget settings.
 * @param ctas
 * @param {Object} ctas - An object containing different call-to-action configurations.
 * @param {Object} ctas.linkFirst - Configuration for the first link CTA.
 * @param {string} ctas.linkFirst.url - URL for the first link CTA.
 * @param {string} ctas.linkFirst.label - Label for the first link CTA.
 * @param {Object} ctas.linkLast - Configuration for the last link CTA.
 * @param {string} ctas.linkLast.url - URL for the last link CTA.
 * @param {string} ctas.linkLast.label - Label for the last link CTA.
 * @param initialized
 * @returns {React.JSX.Element|null}
 * @constructor
 */
const Cta = ({ ctas, initialized }) => {
  const widgetSettings = useContext(WidgetSettingsContext);

  const cta = useMemo(() => {
    const useDefaultLabel = widgetSettings["dcaCTAActionDefaultLabel"];
    const dcaCTAAction = widgetSettings["dcaCTAAction"];

    let cta = ctas[dcaCTAAction];

    if (!cta) {
      return null;
    }

    const label = !useDefaultLabel
      ? widgetSettings["dcaCTAActionLabel"]
      : cta.label;
    const url = cta.url;

    return { label, url };
  }, [widgetSettings, ctas]);

  if (!cta || !cta.url) {
    return null;
  }

  const target =
    widgetSettings["dcaLinkTargetNewTab"] === 1 ? cta.url : "_self";

  return (
    <div
      className={classNames(
        "dce--bar_cta-container dce--bar_cta-container_button",
        {
          "dce--bar_cta-container_button_flash-effect": initialized,
        }
      )}
    >
      <a href={cta.url} className={"dce--bar_cta"} target={target}>
        {cta.label}
      </a>
    </div>
  );
};

export default Cta;
